import { Button } from "@/components/ui/button";
import { OnlineDot } from "@/components/OnlineDot";
import { MessageSquare, FileText } from "lucide-react";

export function OffersTab({ offers, onMessage, onLease }) {
  if (offers.length === 0) {
    return <div className="bg-white border border-border rounded-sm p-12 text-center text-muted-foreground">No offers sent yet.</div>;
  }
  return (
    <div className="space-y-3">
      {offers.map((o) => (
        <div key={o.id} data-testid={`sent-offer-${o.id}`} className="bg-white border border-border rounded-sm p-5 flex flex-col sm:flex-row sm:items-center justify-between gap-3">
          <div>
            <div className="font-display font-semibold flex items-center gap-2">
              {o.title} → {o.tenant_name}
              <OnlineDot online={o.tenant_online} />
            </div>
            <div className="text-sm text-muted-foreground">${o.rent}/mo · {o.lease_length_months}mo · deposit ${o.deposit}</div>
          </div>
          <div className="flex items-center gap-3">
            <span className={`text-xs font-semibold px-2.5 py-1 rounded-full ${o.status === "accepted" ? "bg-emerald-50 text-emerald-700" : o.status === "declined" ? "bg-red-50 text-red-600" : "bg-slate-100 text-slate-600"}`}>{o.status}</span>
            {o.status === "accepted" && (
              <>
                <Button size="sm" variant="outline" onClick={onMessage}><MessageSquare className="w-4 h-4" /></Button>
                {o.lease_signed ? <span className="text-xs text-emerald-700 font-semibold">Lease signed</span> :
                  <Button size="sm" data-testid={`lease-${o.id}`} onClick={() => onLease(o)}><FileText className="w-4 h-4 mr-1" />{o.lease_content ? "Lease sent" : "Deliver lease"}</Button>}
              </>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
